import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { withRouterBridge } from './utils/withRouterBridge';
import Layout from './components/Layout';
import Home from './components/Home';
import Counter from './components/Counter';
import FetchData from './components/FetchData';
import SolarStep1 from './containers/SolarStep1';
import Leistung from './containers/Leistung';
import PowerMaxConsumptionDaily from './containers/PowerMaxConsumptionDaily';
import Vorhersage from './containers/Vorhersage';
import Ist from './containers/Ist';
import IstAllYears from './containers/IstAllYears';
import einnahmen from './containers/einnahmen';
import Durchschnitt from './containers/Durchschnitt';
import Anlage from './containers/Anlage';
import Wechselrichter from './containers/Wechselrichter';
import YearStromGesamt from './containers/YearStromGesamt';
import Evu_pv from './containers/Evu_pv';
import Verbrauch from './containers/Verbrauch';
import EvuBill from './containers/EvuBill';
import PvBill from './containers/PvBill';
import PvFinalBill from './containers/pvFinalBill';
import FinanzUebersicht from './containers/FinanzUebersicht';
import Abschlag from './containers/Abschlag';
import strom from './containers/strom';
import WattAmTagBellCurve from './containers/WattAmTagBellCurve';
import PvJahresvergleich from './containers/PvJahresvergleich';
import BezugAnalyse from './containers/BezugAnalyse';

// Wrap class components to provide Router v4-style props (match, location, history)
const WSolarStep1 = withRouterBridge(SolarStep1);
const WLeistung = withRouterBridge(Leistung);
const WPowerMaxConsumptionDaily = withRouterBridge(PowerMaxConsumptionDaily);
const WVorhersage = withRouterBridge(Vorhersage);
const WIst = withRouterBridge(Ist);
const WIstAllYears = withRouterBridge(IstAllYears);
const Weinnahmen = withRouterBridge(einnahmen);
const WDurchschnitt = withRouterBridge(Durchschnitt);
const WAnlage = withRouterBridge(Anlage);
const WWechselrichter = withRouterBridge(Wechselrichter);
const WYearStromGesamt = withRouterBridge(YearStromGesamt);
const WEvu_pv = withRouterBridge(Evu_pv);
const WVerbrauch = withRouterBridge(Verbrauch);
const WEvuBill = withRouterBridge(EvuBill);
const WPvBill = withRouterBridge(PvBill);
const WPvFinalBill = withRouterBridge(PvFinalBill);
const WFinanzUebersicht = withRouterBridge(FinanzUebersicht);
const WAbschlag = withRouterBridge(Abschlag);
const Wstrom = withRouterBridge(strom);
const WWattAmTagBellCurve = withRouterBridge(WattAmTagBellCurve);
const WPvJahresvergleich = withRouterBridge(PvJahresvergleich);
const WBezugAnalyse = withRouterBridge(BezugAnalyse);
const WCounter = withRouterBridge(Counter);
const WFetchData = withRouterBridge(FetchData);

// eslint-disable-next-line react/display-name
export default () => (
    <Layout>
        <Routes>
            <Route index element={<WSolarStep1 />} />
            <Route path="/step1/:Year?/:Month?" element={<WSolarStep1 />} />
            <Route path="/leistung/:Year?/:Month?" element={<WLeistung />} />
            <Route path="/powermaxconsumptiondaily/:Year?/:Month?" element={<WPowerMaxConsumptionDaily />} />
            <Route path="/vorhersage" element={<WVorhersage />} />
            <Route path="/ist/:Year?" element={<WIst />} />
            <Route path="/istAllYears" element={<WIstAllYears />} />
            <Route path="/einnahmen" element={<Weinnahmen />} />
            <Route path="/strom" element={<Wstrom />} />
            <Route path="/durchschnitt/:Year?" element={<WDurchschnitt />} />
            <Route path="/anlage" element={<WAnlage />} />
            <Route path="/wr" element={<WWechselrichter />} />
            <Route path="/yearstromgesamt/:Year?" element={<WYearStromGesamt />} />
            <Route path="/evu_pv/:Year?" element={<WEvu_pv />} />
            <Route path="/verbrauch/:Year?" element={<WVerbrauch />} />
            <Route path="/evubill" element={<WEvuBill />} />
            <Route path="/pvbill" element={<WPvBill />} />
            <Route path="/abschlag/:Year?" element={<WAbschlag />} />
            <Route path="/pvfinalbill" element={<WPvFinalBill />} />
            <Route path="/finanz" element={<WFinanzUebersicht />} />
            <Route path="/pv-jahresvergleich" element={<WPvJahresvergleich />} />
            <Route path="/strombezug-analyse" element={<WBezugAnalyse />} />
            <Route path="/bellcurve/:Year?/:Month?/:Day?" element={<WWattAmTagBellCurve />} />

            <Route path="/counter" element={<WCounter />} />
            <Route path="/fetchdata/:startDateIndex?" element={<WFetchData />} />
        </Routes>
    </Layout>
);
